var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-search__form"},[_c('autocomplete-control',{ref:"control",attrs:{"placeholder":_vm.$t('Search'),"value":_vm.value,"allow-free-entry":true,"icon":_vm.autocompleteIcon,"request":_vm.doAutocomplete},on:{"input":_vm.emitInput,"select":_vm.emitSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }